const template = require('./index.html')
const makeItLabel = require('@isoftdata/label')
const { v4: uuid } = require('@lukeed/uuid')
const { toLocaleDateString } = require('@isoftdata/utility-date-time')

const defaultOptions = {
	twoway: false,
	lazy: true,
	isolated: true,
}

module.exports = function({ twoway = false, lazy = true, isolated = true } = defaultOptions) {
	return Ractive.extend({
		template,
		isolated,
		twoway,
		lazy,
		partials: {
			append: [],
			prepend: [],
		},
		components: {
			itLabel: makeItLabel(),
		},
		computed: {
			displayValue() {
				const value = this.get('value')

				return this.get('type') === 'date' ? toLocaleDateString(value) : value
			},
		},
		attributes: {
			required: [],
			optional: [
				'id',
				'label',
				'showLabel',
				'name',
				'styleClass',
				'disabled',
				'isLoading',
				'wasSaved',
				'hasError',
				'savedInputIdList',
				'selectOnFocus',
				'sizeClass',
				'textEllipsis',
				'labelParentDivClass',
				'hint',
				'hintClass',
				'labelClass',
				'selectOnFocus',
				'type',
				'value',
				'required',
				'title',
			],
		},
		data() {
			return {
				id: `id${uuid()}`,
				label: null,
				inputmode: 'text',
				showLabel: true,
				name: '',
				styleClass: '',
				disabled: false,
				isLoading: false,
				wasSaved: false,
				hasError: false,
				savedInputIdList: [],
				selectOnFocus: false,
				type: 'text',
				sizeClass: 'form-control-sm',
				tabindex: '',
				textEllipsis: false,
				autocomplete: true,
				labelParentDivClass: 'form-group',
				hint: '',
				hintClass: '',
				labelClass: '',
				required: false,
				title: '',
			}
		},
		clear(value = '') {
			this.find(`#${this.get('id')}`).value = value
		},
		inputFocus() {
			const input = this.find(this.get('id'))

			if (input) {
				input.focus()
			}
		},
		oninit() {
			//this.observe('type', v => console.log(v))
		},
	})
}
